import React from "react";
import { Typography, Paper, Chip, Grid } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import {green} from '@material-ui/core/colors'

import './job.css';
import JobContextMenu from "../job-context-menu/job-context-menu";
import { Component } from "react";

export default class Job extends Component {

    onJobClick = (event) => {
        if (this.props.onJobClick)
            this.props.onJobClick(this.props.job);
    }

    timeValue = () => {

        if (this.props.job.appointmentTime != null)
            return this.props.job.appointmentTime;

        let timeSlot = "AT";

        if (this.props.job.timeSlot === 1)
            timeSlot = "AM";
        else if (this.props.job.timeSlot === 2)
            timeSlot = "PM";

        return timeSlot;
    };

    hasContextMenuActions = () => {
        if (this.props.onMarkJobComplete)
            return true;

        if (this.props.onDeleteJob)
            return true;

        return false;
    };

    getContextMenuActions = () => {
        const items = [];

        if (this.props.onMarkJobComplete)
            items.push({
                action: () => this.props.onMarkJobComplete(this.props.job),
                icon: <CheckIcon style={{color: green[700]}} />,
                text: "Mark as Complete"
            });

        if (this.props.onDeleteJob)
            items.push({
                action: () => this.props.onDeleteJob(this.props.job),
                icon: <ClearIcon color="secondary" />,
                text: "Delete Job"
            });

        return items;
    };

    render() {

        let cursor = (this.onJobClick) 
            ? 'pointer' 
            : 'auto';

        return (<Paper elevation={3} className="job-card" onClick={this.onJobClick} style={{cursor: cursor}}>
            <Grid container justify="space-between">
                <Grid item xs={12}>
                    <Grid container justify="space-between" item xs={12}>
                        <Grid item xs={11}>
                            <Typography variant="body1" component="span"><strong>{this.props.job.addressLine1}</strong></Typography>
                        </Grid>
                        {this.hasContextMenuActions() &&
                            <Grid item xs={1}>
                                <JobContextMenu menuItems={this.getContextMenuActions()} />
                            </Grid>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="textSecondary" variant="caption">Job No: {this.props.job.jobNumber}</Typography>
                    </Grid>
                    <Grid container spacing={1} direction="row" item xs={12}>
                        <Grid item xs="auto">
                            <Chip size="small" color="secondary" variant="outlined" label={"£" + this.props.job.value}></Chip>
                        </Grid>
                        <Grid item xs="auto">
                            <Chip size="small" color="primary" variant="outlined" label={this.timeValue()}></Chip>
                        </Grid>
                        <Grid item xs="auto">
                            <Chip size="small" color="primary" variant="outlined" label={this.props.job.duration + " Hr"}></Chip>
                        </Grid>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography variant="body1">{this.props.job.description}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Paper >);
    }
}